function t(e) {
  switch (e) {
    case "website":
      return "https://www.userbrain.com";
    case "blog":
      return "https://www.userbrain.com/blog";
    default:
      return "";
  }
}
export { t as getBaseWebsiteUrl };